import { useAuth } from '../auth/useAuth'
import { homePathFor } from '../auth/roles'
import { ButtonLink } from '../components/Button'
import { ArrowLeft } from '../components/Icons'
import { t } from '../i18n'

export function ForbiddenPage() {
  const { user } = useAuth()
  return (
    <div className="flex flex-col items-center gap-5 py-24 text-center">
      <span className="font-mono text-[64px] font-medium leading-none tracking-[-0.04em] text-ink-200">403</span>
      <div>
        <h1 className="text-[22px] font-semibold tracking-[-0.02em] text-ink-950">{t('publicPages.forbiddenTitle')}</h1>
        <p className="mt-1.5 max-w-[40ch] text-[14px] text-ink-500">{t('publicPages.forbiddenBody')}</p>
      </div>
      <ButtonLink to={user ? homePathFor(user.role) : '/login'} variant="secondary" icon={<ArrowLeft size={15} />}>
        {t('publicPages.goHome')}
      </ButtonLink>
    </div>
  )
}
